module.exports = __webpack_public_path__ + "media/images/icons/diamond-13e3346c2fb6a5ac030571f0cf9cc001.svg";